class LoadColorsJs extends HTMLElement {
  connectedCallback() {
    const dataElement = this.getAttribute('data-element');
    const productUrl = this.getAttribute('data-product');
    if (!dataElement || !productUrl) return;

    fetch(productUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const el = doc.querySelector(dataElement);
        if (el) {
          this.replaceWith(el);
        }
      })
      .catch(error => {
        this.innerHTML = `<div style="color:red">Failed to load colors: ${error.message}</div>`;
      });
  }
}

if (!customElements.get('load-colors-js')) {
  customElements.define('load-colors-js', LoadColorsJs);
}
